import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

import { Router } from '@angular/router';
import { Observable,throwError  } from 'rxjs';
import { CommonapiService } from '../Module/Shared/Service/Commonapi.service';
import { Common } from '../Module/Shared/Utility/Common';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private router: Router, private authenticationService: CommonapiService) { }
    intercept(request: HttpRequest<any>, newRequest: HttpHandler): Observable<HttpEvent<any>> {
        return newRequest.handle(request).pipe(catchError(err => {
            let error = "";
            if (err.status === 401) {
                //if 401 response returned from api, logout from application & redirect to login page.
                this.authenticationService.Logout("na");
                error = err.error.message || err.statusText;
            }
            return throwError(() => new Error(error));
        }));
    }
}